export const PaginationTotalCount = 'x-pagination-total-count'
export const FeatureUnavailable = 'x-feature-unavailable'
